import React from 'react';
import MediaQuery from 'react-responsive';
import { animateScroll as scroll } from 'react-scroll';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get as getCookie } from 'js-cookie';
import styled from 'styled-components';
import { theme, media } from 'styles';
import { getMarketerSessions } from 'ducks/marketerSessions';
import { fetch as fetchTimeslots, getTimeslots } from 'ducks/timeslots';
import { addItem as addItemToCart } from 'ducks/cart';
import { Button, Container, SeoTags } from 'components/shared';
import guestCartCookieName from 'helpers/guestCartCookieName';
import { Header, SessionPicker, TimeslotPicker } from './components';

const Wrapper = styled.div`
  background-color: #f8fbff;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top 0px right 0px;
  padding-bottom: 100px;

  ${media.laptop`
    padding-bottom: 160px;
  `};
`;

const Headers = styled.div`
  text-align: center;
  margin: 100px 0 40px;
`;

const StyledHeader = styled.h1`
  margin-bottom: ${theme.sp.m};
  padding: 0 40px;
  font-size: 28px;
  line-height: 36px;

  ${media.tablet`
    margin-bottom: ${theme.sp.s};
    padding: 0;
    font-size: 32px;
    line-height: 42px;
  `};
`;

const StyledSubheader = styled.h3`
  padding: 0 40px;

  ${media.tablet`
    padding: 0;
  `};
`;

const CartButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0px;
`;
const AddToCartButton = styled(Button)`
  background: ${theme.colors.blue};
`;

class BookMarketerPage extends React.Component {
  static propTypes = {
    contentfulSessions: PropTypes.arrayOf({}).isRequired,
    marketerSessions: PropTypes.arrayOf({}).isRequired,
    timeslots: PropTypes.arrayOf({}).isRequired,
    onFetchTimeslots: PropTypes.func.isRequired,
    onAddItemToCart: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      marketerSessionId: 0,
      timeslot: '',
    };
    this.setMarketerSessionId = this.setMarketerSessionId.bind(this);
    this.setTimeslot = this.setTimeslot.bind(this);
    this.addToCart = this.addToCart.bind(this);
  }

  setMarketerSessionId(marketerSessionId) {
    this.setState({ marketerSessionId });
    this.props.onFetchTimeslots(marketerSessionId);
    scroll.scrollTo(1000);
  }

  setTimeslot(timeslot) {
    this.setState({ timeslot });
  }

  addToCart() {
    const { marketerSessionId, timeslot } = this.state;
    const id = getCookie(guestCartCookieName);
    return this.props.onAddItemToCart(id, {
      sellableType: 'MarketerSession',
      sellableId: marketerSessionId,
      scheduledTime: timeslot,
    });
  }

  render() {
    const { timeslots, contentfulSessions, marketerSessions } = this.props;
    const { timeslot, marketerSessionId } = this.state;
    return (
      <Wrapper>
        <SeoTags
          title="Book a Free Marketing Consultation | Marketing Experts | MarketTap"
          description="We offer free marketing consultations with our team of experts to help you get closer to achieving your marketing goals. Book a call today."
        />
        <Header />
        <Container>
          <Headers>
            <StyledHeader>What type of call would you like?</StyledHeader>
            <StyledSubheader>
              20, 30, and 60 minute consultations are available.
            </StyledSubheader>
          </Headers>
          <SessionPicker
            onSetMarketerSessionId={this.setMarketerSessionId}
            selectedSessionId={marketerSessionId}
            sessions={marketerSessions.sort((a, b) => a.id - b.id)}
            contentfulSessions={contentfulSessions}
          />
          {!!marketerSessionId && (
            <MediaQuery minDeviceWidth={768}>
              {match => (
                <div>
                  <Headers>
                    <StyledHeader>When should we call you?</StyledHeader>
                    <StyledSubheader>
                      Use the arrows to book up to two weeks out.
                    </StyledSubheader>
                  </Headers>
                  <TimeslotPicker
                    displayPeriodLength={match ? 'weeks' : 'days'}
                    setTimeslot={this.setTimeslot}
                    timeslots={timeslots}
                    selected={timeslot}
                  />
                </div>
              )}
            </MediaQuery>
          )}

          {!!marketerSessionId &&
            !!timeslot && (
              <CartButtonWrapper>
                <AddToCartButton onClick={this.addToCart}>
                  Add to Cart
                </AddToCartButton>
              </CartButtonWrapper>
            )}
        </Container>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  marketerSessions: getMarketerSessions(state),
  timeslots: getTimeslots(state),
});

const mapDispatchToProps = {
  onFetchTimeslots: fetchTimeslots,
  onAddItemToCart: addItemToCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(BookMarketerPage);



// WEBPACK FOOTER //
// ./src/components/BookMarketerPage/BookMarketerPage.jsx